import { Text } from '@/decodo/components/atoms/Text';

export function EmptyOpenPositions() {
  return (
    <div className='dark:border-gray-dark-600 w-full border-t border-gray-200 py-5'>
      <Text color='gray-700'>No open positions at this time.</Text>
    </div>
  );
}
